<template>
	<div>
		<div v-show="Receivable">
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">保洁应收账款表</div>
			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px">
				<!-- 查询框 -->
				<div style="margin-left:3%">
					<div style="height:10px"></div>
					<div style="display:inline-block;margin-top:20px">
						<span>组织架构</span>
						<el-cascader v-model="project_id" @change="changeCascader" clearable
							style="margin-left:10px;width:300px" collapse-tags :props="props"></el-cascader>
					</div>

					<div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>项目名称 </span>
						<el-input v-model="condition.project_name" style="margin-left:10px;width:150px"
							placeholder="请输入项目名称">
						</el-input>
					</div>

					<!-- <div style="display:inline-block;margin-top:20px">
						<span>开票公司 </span>
						<el-input v-model="condition.project_name" style="margin-left:10px;width:150px"
							placeholder="请输入开票公司">
						</el-input>
					</div> -->

					<div style="display:inline-block;margin-top:20px;margin-left:20px">
						<span>月份 </span>
						<el-date-picker style="margin-left:10px" v-model="contract_start_date" type="monthrange" range-separator="至"
							start-placeholder="开始月份" end-placeholder="结束月份" format="yyyy-MM" value-format="yyyy-MM">
						</el-date-picker>
					</div>


					<!-- 按钮 -->
					<div style="display:inline-block;margin:20px;">
						<el-button type="goon" @click="Find">查询</el-button>
						<div style="display:inline-block;margin-left:190px">
							<download-excel class="export-excel-wrapper" :fields="download_excel" title="调岗人员清单"
								name="调岗人员清单.xls" :fetch="ExportForm" style="margin-left:-180px;top:100px">
								<el-button type="goon"
									style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
									导出</el-button>
							</download-excel>
						</div>
					</div>
				</div>

				<!-- 表格 -->
				<div style="margin:1% 3% 0 3%">
					<el-table :header-cell-style="{background:'#d4e9e2',color:'#000000'}"
						:row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
						style="width: 100%;" height="570" @selection-change="handleSelectionChange" border>
						<el-table-column align="center" label="序号" width="50">
							<template slot-scope="scope_1">{{scope_1.$index + 1}}</template>
						</el-table-column>
						<el-table-column align="center" label="组织架构" width="300">
							<template slot-scope="scope">
								{{$globals.group_name + "/" + scope.row.organizeName}}
							</template>
						</el-table-column>
						<el-table-column prop="projectName" align="center" label="项目名称"></el-table-column>
						<el-table-column prop="invoicingFullName" align="center" label="开发票全名" width="100">
						</el-table-column>
						<el-table-column prop="invoicingCompany" align="center" label="开票公司"></el-table-column>
						<el-table-column v-for="(item, index) in titleData" align="center" :label="item.year + '月'"
							:key="index">
							<el-table-column prop="" label="开具日期" align="center">
								<template slot-scope="scope">
									{{scope.row.monthlyList[item.year].issueDate}}
								</template>
							</el-table-column>
							<el-table-column prop="" label="收入额" align="center">
								<template slot-scope="scope">
									{{scope.row.monthlyList[item.year].issueAmount}}
								</template>
							</el-table-column>
							<el-table-column prop="" label="回款日期" align="center">
								<template slot-scope="scope">
									{{scope.row.monthlyList[item.year].paymentDate}}
								</template>
							</el-table-column>
							<el-table-column prop="" label="回款额" align="center">
								<template slot-scope="scope">
									{{scope.row.monthlyList[item.year].repaymentAmount}}
								</template>
							</el-table-column>
							<el-table-column prop="" label="应收款" align="center">
								<template slot-scope="scope">
									{{scope.row.monthlyList[item.year].accountsReceivable}}
								</template>
							</el-table-column>
							<el-table-column prop="" label="未开发票" align="center">
								<template slot-scope="scope">
									{{scope.row.monthlyList[item.year].uninvoiced}}
								</template>
							</el-table-column>
						</el-table-column>
						<el-table-column prop="subtotalIncome" align="center" label="2022年收入小计"></el-table-column>
						<el-table-column prop="collectionIncome" align="center" label="2022年回款小计"></el-table-column>
						<el-table-column prop="subtotalBalance" align="center" label="2022年应收款余额"></el-table-column>
						<el-table-column prop="subtotalIssued" align="center" label="2022年未开发票小计"></el-table-column>
						<el-table-column prop="receivables" align="center" label="2022年应收款已开+未开"></el-table-column>
					</el-table>

					<!-- 分页 -->
					<el-row style=" margin-left: 500px;margin-top:20px ;">
						<el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
							layout=" prev, pager, next, jumper" :total="total">
						</el-pagination>
					</el-row>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	export default {
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				total: 0,
				tableData: [],
				titleData: [],
				timer: '',
				ruleForm: {

				},

				download_excel: {},
				// 权限
				Receivable: true,
				showedit: false,
				editList: {},
				ids: [],
				//条件
				condition: {
					page_num: 1,
					page_size: 10,
					organize_ids: '',
					project_name: '',
					contract_start_date: '',
					contract_end_date: '',
				},
				contract_start_date:[],
				project_id: [],

				//回显查询岗位
				project_ide: '',

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: false,
				},
			};
		},
		methods: {
			a(e){
				console.log(e)
			},
			//组织架构选择
			changeCascader() {
				this.condition.organize_ids = this.project_id[this.project_id.length - 1];
			},
			// 全选
			handleSelectionChange(e) {
				this.ids = [];
				e.forEach(item => {
					this.ids.push(item.id);
				});
			},
			//获取当前时间
			getNowTimes() {
				var date = new Date(),
					year = date.getFullYear(),
					month = date.getMonth() + 1;
				month >= 1 && month <= 9 ? (month = "0" + month) : "";
				var timer = year + '-' + month;
				this.condition.contract_start_date = timer;
				this.condition.contract_end_date = timer;
			},
			// 弹窗
			// handleClose() {
			//     this.dialogVisible = false
			// },
			Return() {
				this.showadd = false;
				this.Receivable = true;
				this.trash();
				this.Find();
			},

			// 操作编辑
			edit(e) {
				this.editList = e;
				this.Receivable = false;
				this.showedit = true;
			},
			//查询
			async Find() {
					if(this.contract_start_date != null && this.contract_start_date != ''){
						this.condition.contract_start_date= this.contract_start_date != null && this.contract_start_date != '' ? this.contract_start_date[0] + '-01' : '';
						this.condition.contract_end_date= this.contract_start_date != null && this.contract_start_date != '' ? this.contract_start_date[1] + '-01' : '';
					}
					var data = await this.$globals.AxiosPost('AccountsInvoiceRegistration/getReceivableList', this.condition);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.tableData = data.list[0].project;
						this.titleData = data.list[0].table;
						this.total = data.total;
					} else {
						this.$message.warning('请求失败！请稍后重试');
					}
				}
			},

			// 导表
			async ExportForm() {
				var temporary = [];
				this.condition.organize_ids.forEach(item => {
					temporary.push(item[item.length - 1]);
				})
				var organize_ids = "";
				temporary.forEach(item => {
					organize_ids += item + ",";
				})

				var url = 'StaffTransfer/selectAlls';
				var record = {
					data_grouping: 'Receivable',
					organize_ids: organize_ids,
					city_id: this.condition.staff.city_id,
					create_time: this.condition.create_time,
					state: this.condition.state,
					applicant_id: this.$globals.user.staff_id,
					staff_name: this.condition.staff.staff_name,
					staff_card: this.condition.staff.staff_card,
					applicant_id: this.$globals.user.staff_id,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === '-2000') {
					this.$message.error('服务器未响应！请稍后重试');
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						if (data.length > 0) {
							this.$message.success("导表成功！文件下载中！");
							return data;
						} else {
							this.$message.success("没有可以导出的数据！");
							return null;
						}

					} else {
						this.$message.warning(data);
					}
				}
			},

			// 操作删除
			async Del(e) {
				var ids;
				if (e === null || e === "" || e === undefined) {
					if (this.ids === null || this.ids.length <= 0) {
						this.$message.warning("请先选择操作数据！");
						return false;
					}
					ids = this.ids;
				} else {
					ids = [e];
				}

				var url = "StaffTransfer/del";
				var record = {
					ids: ids,
				};
				var data = await this.$globals.AxiosPost(url, record);
				if (data === "-2000") {
					this.$message.error("服务器未响应！请稍后重试");
				} else {
					var code = data.code;
					var data = data.data;
					if (code === '200') {
						this.$message.success(data);
						this.trash();
						this.Find();
					} else {
						this.$message.warning(data);
					}
				}
			},
			closeedit() {
				this.showedit = false;
				this.Receivable = true;
			},
			//分页
			handleCurrentChange(val) {
				this.condition.page_num = val;
				this.Find();
			},
			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
				});
				this.organizeList = this.getTreeData(organizeList.data);

			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			}
		},
		async created() {
			this.getNowTimes();
			
			this.organizeFind();
			this.Find();
			
		},
	};
</script>

<style>
	.el-button--goon:focus,
	.el-button--goon:hover {
		background: #006e4b;
		border-color: #05573d;
		color: #fff;
	}

	.el-button--addbtn:focus,
	.el-button--addbtn:hover {
		background: #fff;
		border-color: #05573d;
		color: #006e4b;
	}

	.el-button--goon {
		color: #fff;
		background-color: #006e4b;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-button--addbtn {
		color: #006e4b;
		background-color: #fff;
		border-color: #006e4b;
		font-size: 15px;
		width: 85px;
	}

	.el-table .warning-row {
		background: oldlace;
	}

	.el-table .success-row {
		background: #f0f9eb;
	}

	.el-checkbox__input.is-checked .el-checkbox__inner {
		background-color: #006e4b;
		border-color: #006e4b;
	}

	.el-checkbox__input.is-focus .el-checkbox__inner {
		border-color: #006e4b;
	}

	.el-checkbox__inner:hover {
		border-color: #006e4b;
	}

	.el-button--pic {
		color: #006E4B;
		background-color: #fff;
		border-color: #006E4B;
		font-size: 10px;
		height: 30px;
		width: 70px;
		padding: 10px;
	}

	.el-button--pic:focus,
	.el-button--pic:hover {
		background: #fff;
		border-color: #05573d;
		color: #006E4B;
	}
</style>



// WEBPACK FOOTER //
// Cleaning.vue?06628f50